import React from 'react';
import classnames from 'classnames';
import {BasicInput} from '../FormInputs.react';

export default class TextAreaInput extends BasicInput {
  wrapperRef = React.createRef();

  getInput() {
    const hasErrors = this.props.errors && this.props.errors.size > 0;
    // TODO: Implement a way to overriede default classes (?)
    const inputClasses = classnames(
      'form__field',
      'form__field--textarea',
      this.props.inputClasses,
      {
        error: hasErrors
      }
    );
    return (
      <textarea
        ref={this.wrapperRef}
        name={this.props.name}
        key={this.props.name}
        className={inputClasses}
        disabled={this.props.disabled}
        maxLength={this.props.maxLength}
        value={this.props.value}
        type='text'
        placeholder={this.props.placeholder}
        onBlur={(e) => this.props.onBlur(e)}
        onChange={(e) => this.props.onChange(e)}
        onFocus={(e) => this.props.onFocus(e)}
        defaultValue={this.props.defaultValue}
      />
    );
  }

  getErrors() {
    const {errors} = this.props;
    const hasErrors = this.props.errors && this.props.errors.size > 0;
    if (!hasErrors) {
      return null;
    }

    return errors.map((error, index) => {
      return (
        <div className='form__input-error' key={index}>
          {error}
        </div>
      );
    });
  }

  render() {
    if (this.props.label) {
      return (
        <label className='form__input-wrapper'>
          <div className='form__label-text'>{this.props.label}</div>
          {this.getInput()}
          {this.getErrors()}
        </label>
      );
    }
    return (
      <div className={this.props.className}>
        {this.getInput()}
        {this.getErrors()}
      </div>
    );
  }
}
